import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import content from "@/i18n/thankYou";
import Logo from "@/components/Logo";

export default function ThankYou() {
  useEffect(() => {
    document.title = `${content.title} — Zyravex`;
  }, []);

  return (
    <main className="zx-thankyou">
      <div className="zx-thankyou__panel">
        <Link to="/" className="zx-thankyou__brand" aria-label="Zyravex">
          <Logo />
        </Link>
        <div className="zx-thankyou__mark" aria-hidden="true">
          <svg viewBox="0 0 64 64" width="56" height="56" fill="none">
            <circle cx="32" cy="32" r="30" stroke="#0B2A4A" strokeWidth="3" />
            <path d="M20 33l9 9 16-19" stroke="#0B2A4A" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h1 className="zx-thankyou__title">{content.title}</h1>
        <p className="zx-thankyou__subtitle">{content.subtitle}</p>
        <p className="zx-thankyou__body">{content.body}</p>
        <p className="zx-thankyou__email">
          {content.emailNote}{" "}
          <a href={`mailto:${content.emailAddress}`}>{content.emailAddress}</a>
        </p>
        <Link to="/" className="zx-btn zx-btn--primary zx-btn--lg">
          {content.backHome}
        </Link>
        <p className="zx-thankyou__small">{content.smallPrint}</p>
      </div>
    </main>
  );
}
